const BioMaster = {

    // FIELDS
    "name": "Name",
    "category": "Category",
    "type": "Type",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // OPTIONS
    "nutrient": "Nutrient",
    "chemical": "Chemical",
    "packet": "Packet",
    "quintal": "Quintal",
    "kg": "Kg",

    // PAGE HEADER
    "bioMaster": "Bio Master",

    // ERROR
    "error_name": "Enter Name",
    "error_category": "Select Category",
    "error_type": "Select Type",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_category": 'CATEGORY',
    "table_type": 'TYPE',
    "table_description": 'DESCRIPTION',
    "table_status": "STATUS",

}

export default BioMaster;
